<template>
  <div>
    <a-modal :visible="visible" width="600px" :title="projectId ? '修改项目' : '添加项目'" ok-text="确认" cancel-text="取消" :ok-button-props="{ props: { loading: loading } }" @ok="submit" @cancel="handleCancel">
      <a-form-model ref="modalForm" :model="modalForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol" class="project-modal-form">
        <a-form-model-item label="Logo">
          <a-upload name="resource" list-type="picture-card" class="avatar-uploader compact-logo-uploader" :show-upload-list="false" :headers="headers" :action="actionUrl" :before-upload="beforeLogoUpload" @change="handleChange">
            <div v-if="modalForm.logo">
              <a-avatar shape="square" :size="80" :src="modalForm.logo" style="border-radius: 12px" />
            </div>
            <div v-else>
              <a-icon :type="uploadLoading ? 'loading' : 'plus'" style="font-size: 24px" />
            </div>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="项目名称" prop="name">
          <a-input v-model="modalForm.name" />
        </a-form-model-item>
        <a-form-model-item label="负责人" prop="owner">
          <user-select v-model="modalForm.owner" placeholder="负责人" show-search />
        </a-form-model-item>
        <a-form-model-item label="权重" prop="sort">
          <a-input-number v-model="modalForm.sort" style="width: 100%" :min="0" :max="1000" :default-value="0" />
        </a-form-model-item>
        <a-form-model-item v-if="projectId !== null" label="状态" prop="status">
          <a-radio-group v-model="modalForm.status">
            <a-radio :value="0">启用</a-radio>
            <a-radio :value="1">已归档</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-if="false" label="Jira项目">
          <a-select v-model="modalForm.jira_id" show-search placeholder="Jira项目列表" :filter-option="utils.filterOption">
            <a-select-option v-for="project in jiraProjects" :key="project.project_id" :value="project.project_id">{{ project.project_name }} </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="流程模板">
          <a-select v-model="modalForm.templates" show-search mode="multiple" placeholder="流程模板" :filter-option="utils.filterOption">
            <a-select-option v-for="template in workflowTemplates" :key="template.id" :value="template.id">{{ template.name }} </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="项目描述">
          <a-textarea v-model="modalForm.description" :auto-size="{ minRows: 3 }" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { getCookies } from '@/utils/utils';
import { workflowTemplateList } from '@/api/project/workflow';
import { projectAdd, projectModify, projectDetail, jiraProjectList } from '@/api/project/project';
import UserSelect from '@/components/User/UserSelect';

const getDefaultForm = () => ({
  name: null,
  sort: 0,
  logo: null,
  status: 0,
  jira_id: null,
  level: null,
  owner: null,
  category: null,
  description: null,
  templates: []
});

export default {
  name: 'ProjectModal',
  components: { UserSelect },
  data() {
    return {
      loading: false,
      uploadLoading: false,
      visible: false,
      projectId: null,
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      modalForm: getDefaultForm(),
      uploadData: {},
      jiraProjects: [],
      actionUrl: `${process.env.VUE_APP_DADA_URL}/v1/basic/resourceUpload`,
      headers: {
        Authorization: getCookies()
      },
      rules: {
        logo: [{ required: true, message: 'Logo不能为空', trigger: 'blur' }],
        sort: [{ required: true, message: '权重不能为空', trigger: 'blur' }],
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        owner: [{ required: true, message: '负责人不能为空', trigger: 'blur' }],
        status: [{ required: true, message: '状态不能为空', trigger: 'blur' }]
      },
      workflowTemplates: []
    };
  },
  methods: {
    open(projectId = null) {
      this.visible = true;
      this.projectId = projectId;
      this.modalForm = getDefaultForm();
      this.getJiraProjectList();
      this.getWorkflowTemplateList();
      if (projectId) {
        this.getProjectDetail();
      }
    },
    close() {
      this.visible = false;
      this.loading = false;
      this.uploadLoading = false;
      this.projectId = null;
      this.modalForm = getDefaultForm();
    },
    handleCancel() {
      this.close();
      this.$emit('close');
    },
    getWorkflowTemplateList() {
      workflowTemplateList({ status: 0 }).then(res => {
        this.workflowTemplates = res.data.items || [];
      });
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoading = true;
        return;
      }
      if (info.file.status === 'done') {
        this.uploadLoading = false;
        const { code, message, data } = info.file.response;
        if (code === 2000) {
          this.modalForm.logo = data.resource_url;
        } else {
          this.$message.warning(message);
        }
      }
    },
    getJiraProjectList() {
      jiraProjectList({}).then(res => {
        this.jiraProjects = res.data.items || [];
      });
    },
    getProjectDetail() {
      projectDetail({ project_id: this.projectId }).then(res => {
        const data = res.data;
        this.modalForm = {
          name: data.name,
          sort: data.sort,
          logo: data.logo,
          status: data.status,
          jira_id: data.jira_id,
          level: data.level?.value || null,
          owner: data.owner?.user_id || null,
          category: data.category?.value || null,
          description: data.description,
          templates: data.workflow_templates || []
        };
      });
    },
    submit() {
      this.$refs.modalForm.validate(valid => {
        if (valid) {
          this.loading = true;
          const submitAction = this.projectId ? projectModify({ project_id: this.projectId, ...this.modalForm }) : projectAdd(this.modalForm);
          submitAction
            .then(() => {
              this.close();
              this.$emit('ok');
              this.$message.success(this.projectId ? '项目修改成功' : '项目添加成功');
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    beforeLogoUpload(file) {
      const isImage = ['image/jpeg', 'image/png', 'image/gif', 'image/jpg'].includes(file.type);
      if (!isImage) {
        this.$message.error('仅支持 jpg/jpeg/png/gif 格式的图片!');
        return false;
      }
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isLt1M) {
        this.$message.error('图片大小不能超过 1MB!');
        return false;
      }
      return true;
    }
  }
};
</script>

<style>
.avatar-uploader > .ant-upload,
.compact-logo-uploader > .ant-upload {
  width: 80px;
  height: 80px;
  border-radius: 12px;
  overflow: hidden;
}
.project-modal-form .ant-form-item {
  margin-bottom: 12px;
}
.ant-upload-select-picture-card i {
  font-size: 24px;
  color: #999;
}
.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
